const Login = () => import('@pages/Login')
const Logout = () => import('@components/Logout')
const WxLogin = () => import('@components/WxLogin')
const WxTokenGetter = () => import('@components/WxTokenGetter')
const PasswordReset = () => import('@pages/PasswordReset')

export const auth = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {auth: false}
  },
  {
    path: '/logout',
    component: Logout
  },
  {
    path: '/wx_login',
    component: WxLogin,
    meta: {auth: false}
  },
  {
    path: '/get_wechat_token',
    component: WxTokenGetter,
    meta: {auth: false}
  },
  {
    path: '/password_reset',
    name: 'PasswordReset',
    component: PasswordReset,
    meta: {auth: true}
  }
]



// WEBPACK FOOTER //
// ./src/router/mod/auth.route.js